<template>
<!-- 预览数据弹框 -->
    <div>
        <!-- <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="数据表名称">
                <el-input placeholder="请输入数据表名称" name="tableName" v-model="publichead.tableName" v-if="tableType==1"></el-input>
                <el-input placeholder="请输入数据表名称" name="tableName" v-model="head.tableName" v-else></el-input>
            </el-form-item>
            <el-form-item label="数据表描述">
                <el-input placeholder="请输入数据表描述" name="publicTableDesc" v-model="publichead.publicTableDesc" v-if="tableType==1"></el-input>
                <el-input placeholder="请输入数据表描述" name="extendTableDesc" v-model="head.extendTableDesc" v-else></el-input>
            </el-form-item>
            <el-form-item label="备注">
                <el-input placeholder="请输入备注" name="remark" v-model="publichead.remark" v-if="tableType==1"></el-input>
                <el-input placeholder="请输入备注" name="remark" v-model="head.remark" v-else></el-input>
            </el-form-item>
        </el-form> -->
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="索引" name="index">索引</el-tab-pane>
    <el-tab-pane label="数据库属性" name="db">
        <h3>标准表</h3>
        <el-table :data="viewDialogData.mainFields">
            <el-table-column type="index"></el-table-column>
            <el-table-column label="字段名称" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldName" type="text" v-model="scope.row.dbFieldName" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段备注" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldDesc" type="text" v-model="scope.row.dbFieldDesc" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段长度" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbLength" type="text" v-model="scope.row.dbLength" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="小数点" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbPointLength" type="text" v-model="scope.row.dbPointLength" disabled @keyup.native="regNumber"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="默认值" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbDefaultVal" type="text" v-model="scope.row.dbDefaultVal" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段类型" width=""> 
                    <template slot-scope="scope">
                        <el-select name="dbType" v-model="scope.row.dbType" placeholder="请选择" disabled @change="selectChangeHandler">
                            <el-option
                            v-for="item in getDbTypeList"
                            :key="item.dictValue"
                            :label="item.dictValue"
                            :value="item.dictKey">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="主键" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsKey" type="text" v-model="scope.row.dbIsKey" disabled></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="允许空值" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsNull" type="text" v-model="scope.row.dbIsNull" disabled></el-checkbox>
                    </template>
                </el-table-column>
        </el-table>
        
        <h3>共享表</h3>
        <el-table :data="viewDialogData.publicFields">
            <el-table-column type="index"></el-table-column>
            <el-table-column label="字段名称" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldName" type="text" v-model="scope.row.dbFieldName" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段备注" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldDesc" type="text" v-model="scope.row.dbFieldDesc" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段长度" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbLength" type="text" v-model="scope.row.dbLength" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="小数点" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbPointLength" type="text" v-model="scope.row.dbPointLength" disabled @keyup.native="regNumber"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="默认值" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbDefaultVal" type="text" v-model="scope.row.dbDefaultValue" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段类型" width=""> 
                    <template slot-scope="scope">
                        <el-select name="dbType" v-model="scope.row.dbType" placeholder="请选择" disabled @change="selectChangeHandler">
                            <el-option
                            v-for="item in getDbTypeList"
                            :key="item.dictValue"
                            :label="item.dictValue"
                            :value="item.dictKey">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="主键" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsKey" type="text" v-model="scope.row.dbIsKey" disabled></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="允许空值" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsNull" type="text" v-model="scope.row.dbIsNull" disabled></el-checkbox>
                    </template>
                </el-table-column>
        </el-table>


        <h3>自定义扩展表</h3>
        <el-table :data="viewDialogData.extendFields">
            <el-table-column type="index"></el-table-column>
            <el-table-column label="字段名称" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldName" type="text" v-model="scope.row.dbFieldName" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段备注" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbFieldDesc" type="text" v-model="scope.row.dbFieldDesc" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段长度" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbLength" type="text" v-model="scope.row.dbLength" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="小数点" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbPointLength" type="text" v-model="scope.row.dbPointLength" disabled @keyup.native="regNumber"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="默认值" width=""> 
                    <template slot-scope="scope">
                        <el-input name="dbDefaultValue" type="text" v-model="scope.row.dbDefaultValue" disabled></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="字段类型" width=""> 
                    <template slot-scope="scope">
                        <el-select name="dbType" v-model="scope.row.dbType" placeholder="请选择" disabled @change="selectChangeHandler">
                            <el-option
                            v-for="item in getDbTypeList"
                            :key="item.dictValue"
                            :label="item.dictValue"
                            :value="item.dictKey">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="主键" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsKey" type="text" v-model="scope.row.dbIsKey" disabled></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column label="允许空值" width=""> 
                    <template slot-scope="scope">
                        <el-checkbox name="dbIsNull" type="text" v-model="scope.row.dbIsNull" disabled></el-checkbox>
                    </template>
                </el-table-column>
        </el-table>

    </el-tab-pane>
    </el-tabs>
    </div>
</template>

<script>
import { getDbtypeList } from '@/api/table-extension/table-extension-design'
export default {
    data(){
        return{
            viewDialogData:'',
            activeName:'db',
            getDbTypeList:''
        }
    },
    // methods:{
        
    // },
    created(){
        getDbtypeList().then((res)=>{
        this.getDbTypeList = res.data.data;
        console.log(this.getDbType);
        });
    },
    props:{
        getDbType:{
            type: Array,
            default:()=>{
                return []
            }
        },
        viewdata:{
            type:Object,
            default: () => {
                return {
                // columns: [],
                };
            },
        },
    },
    watch:{
        viewdata:{
            handler(val){
                console.log(val);
                setTimeout(()=>{
                    // this.$set(this,'viewDialogData',val);
                    if(val.extendFields.length>0){
                        val.extendFields.forEach((element,index) => {
                            val.extendFields[index].dbIsKey = this.getIsKey(element.dbIsKey);
                        });
                    }else{
                        val.publicFields.forEach((element,index) => {
                            val.publicFields[index].dbIsKey = this.getIsKey(element.dbIsKey);
                        });
                    }
                    this.viewDialogData = val;
                    console.log(this.viewDialogData);
                });
            },
            deep:true
        },
        
        getDbType:{
            handler(val){
                console.log(val);
                setTimeout(()=>{
                    // this.$set(this,'viewDialogData',val);

                    this.getDbTypeList = val;
                    console.log(this.getDbTypeList);
                });
            },
            deep:true
        },
    },
    methods:{
        getIsKey(val){
            if(val){
                return true
            }else{
                return false
            }
        }
    }
}
</script>

<style>

</style>
